var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.request && _vm.request.status)?_c('tag',{attrs:{"type":_vm.request.status,"size":"mini"}},[_vm._v(_vm._s(_vm._f("trans")(_vm.request.status)))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }